import { calculateCalibratedPrediction } from "./genericHelpers";
import * as constants from "./constants";

/* Returns an array of pathogenicities using databaseThresholds and scores
  eg. -> ["Pathogenic Moderate","Pathogenic Strong"], ["Benign Moderate"], ["Unknown"] 
  If scores is null or empty array, we return ["Unknown"] as pathogenicity. Moreover, if scores
  is not null or empty array, we return ["Unknown"] as pathogenicity if there aren't any threholds
  for the specific database.
  */
export const getCalibratedPredictionPerScore = (databaseThresholds, scores) => {
  if (!scores?.length) {
    return [constants.unknown];
  }

  if (
    !databaseThresholds ||
    (Object.keys(databaseThresholds || {}).length === 0 && scores?.length)
  ) {
    return scores.map(() => {
      return constants.unknown;
    });
  }

  return scores.map((score) => {
    if (score.score === null) return null;

    let finalScore;
    if (score?.score === 0) {
      finalScore = 0;
    } else {
      finalScore = databaseThresholds?.isInverted ? -score.score : score.score;
    }

    return calculateCalibratedPrediction(finalScore, databaseThresholds);
  });
};
